export default function (title: string) {
  return title.trim() ? `${title.trim()} | Crypto Broker Compare` : 'Crypto Broker Compare'
}